import { defineComponent as E, ref as a, watch as k, useId as O, onMounted as _, onUnmounted as w, createElementBlock as C, openBlock as I, createElementVNode as h, withDirectives as b, renderSlot as y, normalizeClass as B, vShow as P, nextTick as S } from "vue";
import { createPopper as $ } from "@popperjs/core";
import { onClickOutside as x } from "@vueuse/core";
import { track as H } from "@ds/tracking/tracking";
const M = ["id"], N = ["id", "aria-describedby"], R = /* @__PURE__ */ E({
  name: "RevPopover",
  __name: "Popover",
  props: {
    contentClassNames: { default: "" },
    modifiers: { default: () => [] },
    position: { default: "top" },
    shouldHideOnClickOutside: { type: Boolean, default: !0 },
    shouldShowOnMount: { type: Boolean, default: !1 },
    triggerElementId: { default: void 0 }
  },
  setup(p) {
    const e = p, s = a(), r = a(), u = a(), t = a(!1), f = a(e.position), i = a(""), l = a("");
    let o = null;
    k(
      () => e.position,
      (n) => {
        o?.setOptions({ placement: n });
      }
    );
    const m = () => {
      H({
        action: "popover",
        context: {
          ...e,
          modifiers: e.modifiers,
          content: i.value,
          status: t.value ? "opened" : "closed",
          trigger: l.value
        }
      });
    };
    async function d() {
      if (!(t.value || !s.value || !u.value || !r.value)) {
        if (t.value = !0, await S(), o === null) {
          const n = (e.triggerElementId && document.getElementById(e.triggerElementId)) ?? u.value;
          if (!n)
            return;
          o = $(n, r.value, {
            modifiers: [
              ...e.modifiers,
              {
                name: "actualPosition",
                enabled: !0,
                phase: "main",
                fn: ({ state: g }) => {
                  f.value = g.placement;
                }
              }
            ],
            placement: e.position
          });
        } else
          o.forceUpdate();
        m();
      }
    }
    const c = () => {
      t.value = !1, m();
    };
    x(s, () => {
      e.shouldHideOnClickOutside && t.value && c();
    });
    const v = O();
    return _(async () => {
      i.value = `content-${v}`, l.value = `trigger-${v}`, e.shouldShowOnMount && (await document.fonts?.ready, d());
    }), w(() => {
      o !== null && (o.destroy(), o = null);
    }), (n, g) => (I(), C("span", {
      ref_key: "el",
      ref: s
    }, [
      h("span", {
        id: l.value,
        ref_key: "triggerEl",
        ref: u
      }, [
        y(n.$slots, "trigger", {
          ariaControls: i.value,
          ariaExpanded: t.value,
          ariaHaspopup: "true",
          hide: c,
          isOpen: t.value,
          show: d
        })
      ], 8, M),
      b(h("div", {
        id: i.value,
        ref_key: "contentEl",
        ref: r,
        "aria-describedby": l.value,
        class: B(p.contentClassNames)
      }, [
        y(n.$slots, "content", {
          hide: c,
          isOpen: t.value,
          position: f.value,
          show: d
        })
      ], 10, N), [
        [P, t.value]
      ])
    ], 512));
  }
});
export {
  R as default
};
